import React from 'react';
import { UserCheck, UserX } from 'lucide-react';
export function WhoItsFor() {
  return <section className="py-20 bg-gray-900 text-white px-4" data-id="element-273">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-274">
        {/* For You */}
        <div className="bg-gray-800 rounded-3xl p-8 md:p-10 border border-green-500/30 relative overflow-hidden" data-id="element-275">
          <div className="absolute top-0 left-0 w-full h-2 bg-green-500" data-id="element-276"></div>
          <div className="flex items-center mb-8" data-id="element-277">
            <div className="w-12 h-12 bg-green-500/20 rounded-full flex items-center justify-center mr-4" data-id="element-278">
              <UserCheck className="w-6 h-6 text-green-400" data-id="element-279" />
            </div>
            <h3 className="text-2xl font-bold" data-id="element-280">Esto ES para ti si:</h3>
          </div>
          <ul className="space-y-6" data-id="element-281">
            <li className="flex items-start" data-id="element-282">
              <span className="text-green-400 mr-3 text-xl" data-id="element-283">✓</span>
              <span className="text-lg text-gray-200" data-id="element-284">
                Eres mujer hispanohablante en USA
              </span>
            </li>
            <li className="flex items-start" data-id="element-285">
              <span className="text-green-400 mr-3 text-xl" data-id="element-286">✓</span>
              <span className="text-lg text-gray-200" data-id="element-287">
                Entiendes algo de inglés pero te congelas al hablar
              </span>
            </li>
            <li className="flex items-start" data-id="element-288">
              <span className="text-green-400 mr-3 text-xl" data-id="element-289">✓</span>
              <span className="text-lg text-gray-200" data-id="element-290">
                Quieres un sistema rápido, práctico y repetible
              </span>
            </li>
          </ul>
        </div>

        {/* Not For You */}
        <div className="bg-gray-800 rounded-3xl p-8 md:p-10 border border-red-500/30 relative overflow-hidden opacity-80" data-id="element-291">
          <div className="absolute top-0 left-0 w-full h-2 bg-red-500" data-id="element-292"></div>
          <div className="flex items-center mb-8" data-id="element-293">
            <div className="w-12 h-12 bg-red-500/20 rounded-full flex items-center justify-center mr-4" data-id="element-294">
              <UserX className="w-6 h-6 text-red-400" data-id="element-295" />
            </div>
            <h3 className="text-2xl font-bold" data-id="element-296">NO es para ti si:</h3>
          </div>
          <ul className="space-y-6" data-id="element-297">
            <li className="flex items-start" data-id="element-298">
              <span className="text-red-400 mr-3 text-xl" data-id="element-299">✕</span>
              <span className="text-lg text-gray-300" data-id="element-300">
                Buscas inglés académico, certificaciones o gramática profunda
              </span>
            </li>
            <li className="flex items-start" data-id="element-301">
              <span className="text-red-400 mr-3 text-xl" data-id="element-302">✕</span>
              <span className="text-lg text-gray-300" data-id="element-303">
                Empiezas desde cero total y necesitas bases completas
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}